/** TanStack Query keys — one place so every feature invalidates consistently. */
export const qk = {
  me: ["me"] as const,
  assignments: ["me", "assignments"] as const,
  recordings: ["me", "recordings"] as const,
  profile: ["me", "profile"] as const,
  sessions: ["account", "sessions"] as const,
  setupState: ["auth", "setup"] as const,
  invitePreview: (token: string) => ["auth", "invite", token] as const,

  // extension points for the annotator / adjudicator / admin features
  annotateQueue: (filters: Record<string, unknown> = {}) => ["annotate", "queue", filters] as const,
  annotateItem: (recordingId: string) => ["annotate", recordingId] as const,
  annotateRereview: ["annotate", "rereview"] as const,
  arbitrationQueue: ["arbitration", "queue"] as const,
  arbitrationItem: (recordingId: string) => ["arbitration", recordingId] as const,
  qualitySummary: ["quality", "summary"] as const,
  qualityAnnotators: ["quality", "annotators"] as const,
  /** B5 周度 IAA (ISO 周 · Asia/Shanghai). */
  qualityWeekly: (weeks = 8) => ["quality", "weekly", weeks] as const,
  materials: (filters: Record<string, unknown> = {}) => ["materials", filters] as const,
  speakers: ["speakers"] as const,
  speakerRecordings: (id: string) => ["speakers", id, "recordings"] as const,
  batchStudents: (id: string) => ["batches", id, "students"] as const,
  batches: ["batches"] as const,
  recording: (id: string) => ["recording", id] as const,

  // 课程团队 / 管理端 (docs/UX.md 11–18)
  material: (id: string) => ["materials", "detail", id] as const,
  batch: (id: string) => ["batches", "detail", id] as const,
  qcQueue: (state = "uploaded") => ["qc", "queue", state] as const,
  /** T7 示范录音清单 (routes/stimuli.ts). */
  stimuli: ["stimuli"] as const,
  exportVersions: ["export", "versions"] as const,
  adminUsers: ["admin", "users"] as const,
  adminInvitations: ["admin", "invitations"] as const,
  adminAudit: (userId?: string) => ["admin", "audit", userId ?? "all"] as const,
  classes: ["classes"] as const,
  teacherDashboard: (classId?: string) => ["teacher", "dashboard", classId ?? "all"] as const,
  /** C3 班级覆盖热图 — keyed by class and column axis. */
  teacherCoverage: (classId?: string, axis = "stage") =>
    ["teacher", "coverage", classId ?? "all", axis] as const,
  /** ACCOUNTS.md §4 — the account's optional verified email. */
  accountEmail: ["account", "email"] as const,
  /** ACCOUNTS.md §4 — the account's optional verified phone. */
  accountPhone: ["account", "phone"] as const,
  classMembers: (classId: string) => ["classes", classId, "members"] as const,
  classInvitations: (classId: string) => ["classes", classId, "invitations"] as const,
  /** B8 运维 (docs/DEPLOY.md) — admin only. */
  adminBackups: ["admin", "backups"] as const,
  adminAi: ["admin", "ai"] as const,
  healthDeep: ["health", "deep"] as const,
  speakersFiltered: (filters: Record<string, unknown> = {}) => ["speakers", filters] as const,
};
